<template>
  <v-layout row :class="{'list': list}">
    <v-flex xs1 class="order-status text-xs-center">
      <v-icon class="new">check</v-icon>
    </v-flex>
    <v-flex xs11>
      <v-container ma-0 pa-0 pl-3 fluid>
        <v-layout row>
          <v-flex>
            <strong class="fs-18">
              Pedido n° {{ value.register }}
            </strong>
          </v-flex>
          <v-flex class="text-xs-right mt-2">
            {{ date }}
          </v-flex>
        </v-layout>
        <v-layout row v-if="value.condominium !== null">
          <v-flex class="order-color">
            {{ value.condominium.name }}<br>
            Cliente: {{ value.client }}<br>
            Unidade: {{ value.unit }}<br>
          </v-flex>
        </v-layout>
        <v-layout row mb-2 mt-2>
          <v-flex class="order-color">
            <strong>Itens Pedidos</strong><br>
            <template lang="html" v-for="item in value.itens">
              <span :key="item.id">
                {{ item.name }};
              </span>
            </template>
          </v-flex>
        </v-layout>
        <v-layout row mb-5>
          <v-flex>
            <div class="fs-18 mt-1">
              <strong>Valor total</strong>: {{ price | currency }}
            </div>
          </v-flex>
          <v-flex class="text-xs-right">
            <v-btn class="elevation-0 order-details-btn ma-0" v-on:click="orderDetails(value.id)">+ detalhes</v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-flex>
  </v-layout>
</template>

<script>
import moment from 'moment'
export default {
  name: 'order',
  props: {
    value: {
      type: Object
    },
    list: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      oi: '3232',
      date: null
    }
  },
  computed: {
    price () {
      return this.value.itens.reduce((prevVal, elem) => {
        return prevVal + elem.price
      }, 0)
    }
  },
  filters: {
    currency (value) {
      if (typeof value !== 'number') return ''
      return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
    }
  },
  methods: {
    orderDetails (id) {
      this.$store.dispatch('selectOrder', id)
    }
  },
  mounted () {
    moment.locale('pt-br')
    this.date = moment(this.value.date).calendar(null, {
      sameDay: '[Hoje às] h:mm',
      nextDay: '[Tomorrow] h:mm',
      nextWeek: '[Próxima] dddd',
      lastDay: '[Ontem às] h:mm',
      lastWeek: 'dddd [passada]',
      sameElse: 'DD MMM [às] h:mm'
    })
    // this.date = moment(this.value.date).calendar()
  }
}
</script>
<style>
.fs-18{
  font-size: 18px;
}
.new{
  color: red!important;
}
.order-details-btn div{
  background: #0264c7;
  padding: 5px 10px;
  float: left;
  color: #fff;
  cursor: pointer;
}
.order-status::after{
  content: ' ';
  display: block;
  height: calc(100% - 40px);
  border-left: 1px solid #c7c7c7;
  width: 1px;
  margin: auto;
  margin-top: 10px;
}
.order-color{
  color:#767676
}
.list .order-status{
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// index.vue?1a275da6